import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class SubtraidEmployeeGuard implements CanActivate {
  constructor(
    private AuthService: AuthService,
    private router: Router
  ) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    
      if (this.AuthService.isSubtraidEmployee()) {
        
      return true;
    } else {
      // this.router.navigate(["login"]);
      
      this.router.navigate(['admin-login']);
      return false;
    }
  }


}
